/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable @typescript-eslint/camelcase */
import React, { useContext } from 'react';
import CustomButton from '../../../../shared/forms/CustomButton';
import AppContext from '../../../../../../context/shared/AppContext';
import Label from '../../../../shared/forms/Label';
import CustomInput from '../../../../shared/forms/CustomInput';

const AddSnmp = () => {
  const { loadingForm, onChange, formValue, onSubmit } = useContext(AppContext);
  const { ssid, cacti, ip_address, device_name } = formValue;
  const submitForm = () => {
    return ip_address.length > 0 && cacti.length > 0 && ssid.length > 0 && device_name.length;
  };
  return (
    <div id="add-access-point" className="modal fade mt-5" role="dialog">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header shadow">
            <h4 className="modal-title update_asset">SNMP</h4>
            <button type="button" className="btn btn-outline-info btn-circle btn-close" data-dismiss="modal">
              x
            </button>
          </div>
          <div className="modal-body detail mb-4 p-0">
            <form
              className="col-md-12 p-0"
              onSubmit={(e) => {
                e.preventDefault();
                onSubmit();
              }}
            >
              <div className="d-flex">
                <div className="form-group col-6">
                  <Label classname="m-0 p-0 copy-font" name="IP Address" />
                  <CustomInput
                    classname="form-control border border-info p-2"
                    name="ip_address"
                    value={ip_address}
                    onChange={onChange}
                    readOnly={false}
                    placeholder="eg (10.1.2.10)"
                    type="text"
                    id="customerEmail"
                  />
                </div>
                <div className="form-group col-6">
                  <Label classname="m-0 p-0 copy-font" name="Device Name" />
                  <CustomInput
                    classname="form-control border border-info p-2"
                    name="device_name"
                    value={device_name}
                    onChange={onChange}
                    readOnly={false}
                    placeholder=""
                    type="text"
                    id="customerEmail"
                  />
                </div>
              </div>
              <div className="d-flex">
                <div className="form-group col-6">
                  <Label classname="m-0 p-0 copy-font" name="Cacti" />
                  <CustomInput
                    classname="form-control border border-info p-2"
                    name="cacti"
                    value={cacti}
                    onChange={onChange}
                    readOnly={false}
                    placeholder=""
                    type="text"
                    id="customerEmail"
                  />
                </div>
                <div className="form-group col-6">
                  <Label classname="m-0 p-0 copy-font" name="SSID" />
                  <CustomInput
                    classname="form-control border border-info p-2"
                    name="ssid"
                    value={ssid}
                    onChange={onChange}
                    readOnly={false}
                    placeholder=""
                    type="text"
                    id="customerEmail"
                  />
                </div>
              </div>

              <div className="text-center mt-3">
                {loadingForm ? (
                  <CustomButton classname="btn btn-green px-3" name="Adding..." disabled={loadingForm} />
                ) : (
                  <CustomButton classname="btn btn-green px-3" name="Add" disabled={!submitForm()} />
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddSnmp;
